var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AsideIcon",on:{"click":_vm.upAside}},[_c('i',{staticClass:"AsideIcon-icon el-icon-s-operation"})])}
var staticRenderFns = []

export { render, staticRenderFns }